
/**
 * API utilities for making authenticated requests
 */

// Use exact API key that works in Postman
const API_KEY = "a6fcb1b0-6a77-4c57-8493-108adcf96c61";

// Access token from environment variables
const getAuthToken = () => {
    // First try to get from environment
    const localStorageToken = localStorage.getItem('token')
    const token = localStorageToken || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjEwNywiZW1haWwiOiJqb2huQGV4YW1wbGUuY29tIiwibmFtZSI6IkpvaG4gRG9lIiwicm9sZSI6IiIsImlhdCI6MTc0NzIyMjU2MCwiZXhwIjoxNzQ3MjI2MTYwfQ.JlpWtI3wFbLLa9uo5fu4p9jY0WeooxtFi08ERFDfT4I'
    if (typeof process !== 'undefined' && token) {
        return token;
    }
    // Fallback to sessionStorage if needed
    if (typeof window !== 'undefined') {
        return sessionStorage.getItem('token') || '';
    }
    return '';
};

/**
 * Make an API request to internal Next.js API routes and n8n webhooks only
 * For app.rivio.io API calls, use useDevices() hook or useRivioApi() hook instead
 */
export const apiRequest = async (url, options = {}) => {
    try {
        // Check if this is an n8n webhook URL
        const isN8nWebhook = url.includes('n8n.rivio.io/webhook');

        // Create headers object
        const headers = {};

        // Only add authorization for non-webhook URLs
        if (!isN8nWebhook) {
            headers['Authorization'] = `Bearer ${getAuthToken()}`;
        }

        // Merge options.headers with the default headers
        options.headers = new Headers({
            ...headers,
            ...(options.headers || {}),
        });

        // Only add Content-Type if not a FormData request
        if (!(options.body instanceof FormData)) {
            options.headers.append('Content-Type', 'application/json');
        }

        // Make request
        const response = await fetch(url, options);

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`API Error (${response.status}): ${errorText}`);

            throw new Error(`API request failed: ${response.status} - ${errorText}`);
        }

        return response;
    } catch (error) {
        console.error('API Request Failed:', error);
        throw error;
    }
};

// For backward compatibility
export const getAuthHeaders = () => ({
    'Content-Type': 'application/json',
    'api-key': API_KEY
});
